<ng-template #content let-modal>
  <dcp-categories-menu [modal]="modal"></dcp-categories-menu>
</ng-template>

<div
  class="highlightable-header-tab py-4 ms-sm-4 me-sm-0 ms-md-5 d-flex justify-content-center flex-column dropdown-toggle">
  <div (click)="open(content)" (keyup.enter)="open(content)"
       [tabindex]="0" class="ds-color--white mx-sm-2 d-flex align-items-center focusable focusable__element">
    <span class="ds-icon--big ds-icon--burger"></span>
    <span class="ms-2 d-none d-md-inline-block">{{'categories.browse' | cxTranslate}}</span>
  </div>
</div>
